import { useLabels } from 'components/general/Label';
import React from 'react';
import Sprites from "styles/images/SpriteIcons.svg";



/**
     * Get the result status as integer value used in wrs
     * 
     * @param className set class  of svg
     * @param code set code of svg
     * @param title title as code of label 
     * @param fill set fill 
     * @param titleIsText use title as text 
     * @param ariaHidden set aria-hidden by default false and it  no set , only set on true (usualy as image )
     * @param insideBtn use inside of a button example 
     * 
     * @return svg tag
     */
const SvgMirs = ({ className, code, title, fill, titleIsText = false, insideBtn = false, ariaHidden = false }) => {
    const fLabel = useLabels();
    let stitle
    let ocsLabel

    if (titleIsText) {
        stitle = title
        ocsLabel = title

    } else {
        if (title) {
            stitle = fLabel({ data: title })
            ocsLabel = title
        } else {
            stitle = getLabel(fLabel, code)
            ocsLabel = getLabel(undefined, code)
        }
    }

    if (insideBtn) {
        //focusable="false" support older browser
        return (
            < svg focusable="false" className={className} aria-hidden={ariaHidden ? ariaHidden : null} data-ocs-label={ocsLabel}><use xlinkHref={`${Sprites}#${code}`} fill={fill} /></svg>
        )

    } else {
        if ((stitle && typeof stitle === 'object') || (stitle && stitle !== '' && !stitle.includes(".legend"))) {
            return (
                < svg role="img" className={className} aria-hidden={ariaHidden ? ariaHidden : null} data-ocs-label={ocsLabel}><title>{stitle}</title><use xlinkHref={`${Sprites}#${code}`} fill={fill} /></svg>
            )
        } else {//Case stitle is empty
            return (
                < svg focusable="false" className={className} aria-hidden={ariaHidden ? ariaHidden : null} data-ocs-label={ocsLabel}><use xlinkHref={`${Sprites}#${code}`} fill={fill} /></svg>
            )
        }
    }
}



export function getLabel(fLabel, code) {
    const label = {
        "yellow-card": "LabelYellowCard", //LabelYCDesc
        "circle-check": "HeaderWinner",
        "camera": "LabelPhotoFinish",
        "red-card": "LabelRedCard", //LabelRCDesc
        "arrow-up": "LabelMoveUp",
        "arrow-down": "LabelMoveDown",
        "white-card": "HeaderWCDesc",

        // "arrowLeft": "", only inside button 
        // "arrowRight": "", only inside button 
        //"maximize": "",, only inside button
        //"minimize": "",, only inside button

        "warning": "HeaderWarning",
        "horse": "HeaderHorse",
        "circle": "HeaderWinner", //poner a mano 
        "thumbtack": "",//addFavorite
        "file-pdf": "LabelPdfFile",
        "medal": "LabelMedal",// este es undor la flota manual
        "volleyball": "serving",

        //"doble-left": "", //only inside button
        //"doble-right": "",//only inside button
        "video": "LabelIVRDesc",
        "futbol": "",// solo tEQ kracoviaponer a mano

        //"left": "" //only inside button
        //"right": "",//only inside button
        //"caretdown": "",//only inside button
        //"caretright": "",//only inside button

        "themecolor": "themecolor",
        "check": "check",
        "asterisk": "asterisk",
        "card": "card",
        "square": "square",
        //"minus": "",//only inside button
        // "plus": "",//only inside button

    }
    
    return fLabel ? (fLabel({ data: label[code] })) : label[code];
}


export default SvgMirs;